import React, { createContext, useContext, useState, useMemo } from 'react'

type SelectedFrameContextValue = {
  selectedFrameUUID: string | null
  setSelectedFrameUUID: (uuid: string | null) => void
}

const SelectedFrameContext = createContext<
  SelectedFrameContextValue | undefined
>(undefined)

type SelectedFrameProviderProps = {
  children: React.ReactNode
}

/**
 * Provider that tracks the currently selected frame in view mode (outside of Inspector).
 * This allows other components like the copy link shortcut to know which frame is selected.
 */
export function SelectedFrameProvider({
  children,
}: SelectedFrameProviderProps) {
  const [selectedFrameUUID, setSelectedFrameUUID] = useState<string | null>(
    null
  )

  const value = useMemo(
    () => ({
      selectedFrameUUID,
      setSelectedFrameUUID,
    }),
    [selectedFrameUUID]
  )

  return (
    <SelectedFrameContext.Provider value={value}>
      {children}
    </SelectedFrameContext.Provider>
  )
}

/**
 * Hook to access the selected frame context.
 * Returns undefined if not inside a SelectedFrameProvider.
 */
export function useSelectedFrame() {
  return useContext(SelectedFrameContext)
}
